import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { metadataIdFixer } from '@bibliocommons/utils-link';
import { makeBibJacketCoverAltText } from 'app/helpers/bib/bibHelpers';
import { bindAll } from '@bibliocommons/utils-react';
import BibBrief from 'app/components/shared/BibBrief';
import JacketCover from '@bibliocommons/shared-jacket-cover';

import { AggregateRatingContainer } from 'app/components/shared/AggregateRating';
import BibSeries from 'app/components/shared/BibSeries';
import SearchAnalyticsContext from 'app/components/search/SearchAnalyticsContext';
import RecommendationsContainer from '../Recommendations';
import ManifestationList from '../ManifestationList';

class SearchResultItemContent extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  renderSeries() {
    if (this.props.showSeries) {
      return (
        <span className="series-list">
          <p>
            <FormattedMessage id="series" />:
          </p>
          {this.props.item
            .getIn(['briefInfo', 'series'])
            .valueSeq()
            .map(series => (
              <BibSeries series={series} />
            ))}
        </span>
      );
    }
    return null;
  }

  renderManifestations() {
    const { itemPosition, manifestations, reciprocalRank } = this.props;
    return (
      <ManifestationList manifestations={manifestations} reciprocalRank={reciprocalRank} itemPosition={itemPosition} />
    );
  }

  render() {
    const { trackJacketClick, itemPosition, manifestations } = this.props;

    const { trackBibAuthorClick, trackBibTitleClick } = this.context;

    const totalCount = manifestations.count();
    const bibTitle = this.props.item.getIn(['briefInfo', 'title']);
    const bibCoverAltText = makeBibJacketCoverAltText(bibTitle, this.props.item.getIn(['briefInfo', 'authors']));
    const jacketSource = this.props.item.getIn(['briefInfo', 'jacket']);
    const searchResultItemContentClasses = cn('cp-search-result-item-content');
    const rating = this.props.item.getIn(['briefInfo', 'rating', 'averageRating']) || 0;

    return (
      <div className={searchResultItemContentClasses}>
        <div className="cp-search-result-item-info">
          <div className="jacket-cover-wrap hidden-md hidden-lg">
            <a
              href={`/item/show/${metadataIdFixer(this.props.item.get('id'))}`}
              title={bibTitle}
              target="_parent"
              onClick={trackJacketClick}
            >
              <JacketCover
                src={jacketSource}
                format={this.props.item.getIn(['briefInfo', 'format'])}
                alt={bibCoverAltText}
                variant="search"
              />
            </a>
          </div>
          <div>
            <BibBrief
              bib={this.props.item.get('briefInfo')}
              handleBibTitleClick={childPayload =>
                trackBibTitleClick({
                  itemPositionGrouped: 0,
                  itemPosition,
                  totalCount,
                  ...childPayload
                })}
              renderAuthorsAsLink
              reciprocalRank={this.props.reciprocalRank}
              titleTag="h3"
              trackAuthorClick={childPayload =>
                trackBibAuthorClick({
                  itemPositionGrouped: 0,
                  itemPosition,
                  totalCount,
                  ...childPayload
                })}
            >
              {this.renderSeries()}
            </BibBrief>
            {Boolean(rating) && (
              <div className="rating">
                <AggregateRatingContainer metadataId={this.props.item.get('id')} />
              </div>
            )}
          </div>
        </div>

        <div className="info">
          <div className="row">
            <div className="col-12 col-xs-12 availability_status">{this.renderManifestations()}</div>
          </div>
        </div>
        <RecommendationsContainer manifestations={manifestations} />
      </div>
    );
  }
}

SearchResultItemContent.contextType = SearchAnalyticsContext;

SearchResultItemContent.propTypes = {
  item: ImmutablePropTypes.map,
  itemPosition: PropTypes.number,
  showSeries: PropTypes.bool,
  reciprocalRank: PropTypes.number,
  manifestations: ImmutablePropTypes.list,
  trackJacketClick: PropTypes.func.isRequired
};

export default SearchResultItemContent;
